var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "score-panel" },
    [
      _vm.heading
        ? _c("h3", {
            staticClass: "title is-6 column-title",
            class: { "column-tooltip": _vm.tooltip },
            domProps: { textContent: _vm._s(_vm.heading) },
          })
        : _vm._e(),
      _vm.tooltip
        ? _c("tooltip", {
            staticClass: "feature",
            attrs: {
              icon: "question-circle",
              library: "fas",
              position: "is-left",
              tip: _vm.tooltip,
              size: "is-medium",
            },
          })
        : _vm._e(),
      _vm.scoreData
        ? _c("div", [
            _vm.subtitle
              ? _c("p", { staticClass: "is-size-6" }, [
                  _vm._v(_vm._s(_vm.subtitle)),
                ])
              : _vm._e(),
            _c("p", { staticClass: "is-size-3" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.count) + " / " + _vm._s(_vm.goal)),
              ]),
            ]),
            _c(
              "progress",
              {
                class: _vm.progressClass,
                attrs: { max: "100" },
                domProps: { value: _vm.score },
              },
              [_vm._v(" " + _vm._s(_vm.score) + " % ")]
            ),
          ])
        : _c(
            "div",
            [
              _vm.isFetching
                ? _c("dc-icon", {
                    attrs: { icon: "sync", "no-margin": "", spin: "" },
                  })
                : _vm._e(),
              _c("span", { domProps: { textContent: _vm._s(_vm.label) } }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }